module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view__tabs"
  }, [_c('ul', {
    staticClass: "view__tabs--menu"
  }, [_c('li', {
    class: _vm.getCssClass(['member-detail', 'member'])
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'member-detail',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_Definition')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass(['member-history', 'member-invoice'])
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'member-history',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_Subscriptions')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('member-audit-logs')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'member-audit-logs',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize('Label_AuditLogs')) + "\n            ")])], 1)]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "label": _vm.actions.label,
      "links": _vm.actions.links,
      "isNotSync": true,
      "acc": "actions"
    },
    on: {
      "delete": _vm.deleteMember
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fdd57d4!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/Submenu.vue
// module id = 720
// module chunks = 1